import React, { useState } from "react";
import PropTypes from "prop-types";
import { put } from "@rails/request.js";
import Spinner from "./Spinner";
import { FormFields } from "./styles";

/*
 * CaptionInput component
 */
const CaptionInput = ({ photoId, prevCaption }) => {
  const [caption, setCaption] = useState(!prevCaption ? "" : prevCaption);
  const [saving, setSaving] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);

  const onInputChange = (e) => {
    setCaption(e.target.value);
    if (!showSaveBtn) setShowSaveBtn(true);
  };

  const handleSaveCaption = async () => {
    try {
      setSaving(true);
      const payload = { body: JSON.stringify({ id: photoId, caption }) };
      const response = await put(
        "/accounts/update_share_photos_caption",
        payload
      );
      if (response.ok) {
        const data = await response.json;
        setSaving(false);
        setShowSaveBtn(false);
      } else {
        throw new Error(response);
      }
    } catch (e) {
      setSaving(false);
      console.log("Error saving caption", e);
    }
  };

  return (
    <FormFields className="flex items-center justify-center mt-6">
      <input
        autoComplete="off"
        className={`${saving ? "disabled" : ""}`}
        onKeyUp={(e) => (e.key === "Enter" ? handleSaveCaption() : null)}
        onChange={(e) => onInputChange(e)}
        id="captionInput"
        maxLength="50"
        placeholder="Add A Caption (Optional)"
        type="text"
        value={caption}
        disabled={saving}
      />
      <Spinner saving={saving} />

      {showSaveBtn && (
        <button
          className="ml-3 ml-1 btn btn-solid"
          onClick={() => handleSaveCaption()}
        >
          Save
        </button>
      )}
    </FormFields>
  );
};

CaptionInput.propTypes = {
  photoId: PropTypes.number.isRequired,
  prevCaption: PropTypes.string,
};

export default CaptionInput;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/SharePhotoModal/CaptionInput/index.jsx